import { Column } from '@melements/front-components/dist/components/list/table/Table.types';

import { DownloadButtonContainer } from './downloadButton/DownloadButtonContainer';

// tslint:disable-next-line:prefer-array-literal
const COLUMNS_ARRAY: Array<Column<any>> = [
  {
    key: 'fileName',
    name: { id: 'REPORTS.TABLE.COLUMNS.API_REPORT_NAME' },
  },
  {
    key: 'creationDate',
    name: { id: 'REPORTS.TABLE.COLUMNS.DATE' },
  },
  {
    component: DownloadButtonContainer,
    headerStyle: { width: '8rem' },
    key: 'action',
    name: { id: 'REPORTS.TABLE.COLUMNS.ACTION' },
  },
];

export const COLUMNS = [COLUMNS_ARRAY];
